import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/page/home'
import Test from '@/components/page/test'
import Safesystem from '@/components/page/safesystem'
import taijia from '@/components/page/taijia'
import qtape from '@/components/page/qtape'
import antape from '@/components/page/antape'

Vue.use(Router)

const router  = new Router({
  mode: 'history',  
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/safesystem',
      name: 'safesystem',
      component: Safesystem
    },
    {
      path: '/taijia',
      name: 'taijia',
      component: taijia
    },
    {
      path: '/qtape',
      name: 'qtape',
      component: qtape
    },
    {
      path: '/antape',
      name: 'antape',
      component: antape
    },
    {
      path: '/test',
      name: 'test',
      component: Test
    }
  ]
});
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  
  document.documentElement.scrollTop = 0; 
  window.pageYOffset = 0; 

  next();
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js